import axios from 'axios';//引入axios
// import QS from 'qs'; // 引入qs模块，用来序列化post类型的数据，后面会提到
axios.defaults.baseURL = 'https://lesson-api.feng-xiu.top/ht'
// axios.defaults.baseURL = '/api'

axios.defaults.timeout = 500000000;//加载不出来5秒之后就是加载失败
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.headers.post['Content-Type'] = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

//请求拦截器
axios.interceptors.request.use(
    config => {
        config.headers.Authorization = window.localStorage.getItem('token')
        return config;
    },
    error => {
        return error;
    }
)
//响应拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        return error;
    }
)

export default axios
// 使用promise返回axios请求的结果
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
};
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params))
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}